import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(frontend)/bike-tours/page/[pageNumber]/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BikingAdventureCard"] */ "/app/src/components/BikingAdventureCard/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Pagination"] */ "/app/src/components/Pagination/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TourHero"] */ "/app/src/heros/TourHero/index.tsx");
